import { useLocation } from 'react-router'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { DialogLayout } from 'pages/chatbot/ui'
import { useChatbotContext, useChatbotDialogContext } from 'pages/chatbot/context'
import { AgentDialog } from './AgentDialog'

export const AgentNewDialog = observer(() => {
  const { started, start } = useChatbotDialogContext()
  const { state: payload } = useLocation()
  const { agentBookAppointmentStepsStore } = useChatbotContext()

  useEffect(() => {
    if (payload?.test) start(agentBookAppointmentStepsStore.settingAgentStore.isAutoConvType)
  }, [])

  return (
    <DialogLayout active={started}>
      <AgentDialog />
    </DialogLayout>
  )
})
